import {
  ButtonGroup,
  Content,
  Dialog as SpectrumDialog,
  Divider,
  Heading,
} from '@adobe/react-spectrum';
import { Button } from './button';

export type dialogSize = 'S' | 'M' | 'L';

export interface DialogButtonProps {
  onClick: () => void | Promise<void>;
  label: React.ReactNode;
}

interface DialogProps {
  size?: dialogSize;
  title: React.ReactNode;
  children: React.ReactNode;
  mainButtonProps: DialogButtonProps;
  subButtonProps?: DialogButtonProps;
}

export const Dialog = (props: DialogProps) => {
  const {
    size = 'M',
    title,
    children,
    mainButtonProps,
    subButtonProps,
  } = props;

  const handleMainOnClick = async () => {
    await mainButtonProps.onClick();
  };

  const handleSubOnClick = async () => {
    if (!subButtonProps) return;
    await subButtonProps.onClick();
  };

  return (
    <SpectrumDialog size={size}>
      <Heading>{title}</Heading>
      <Divider />
      <Content>{children}</Content>
      <ButtonGroup>
        {subButtonProps && (
          <Button variant="secondary" onClick={handleSubOnClick}>
            {subButtonProps.label}
          </Button>
        )}
        <Button variant="cta" onClick={handleMainOnClick}>
          {mainButtonProps.label}
        </Button>
      </ButtonGroup>
    </SpectrumDialog>
  );
};
